import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import {
  DashboardCardComponent,
  DashboardCardFooterDirective,
  DashboardCardHeaderActionsDirective,
} from '@catch/general-ui';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronRight, faEnvelope } from '@fortawesome/pro-light-svg-icons';
import { TranslocoPipe } from '@jsverse/transloco';
import { PlatformDashboardService } from '../../../../services/platform-dashboard.service';
import { PlatformDashboardInvitationItemComponent } from '../dashboard-invitation-item/platform-dashboard-invitation-item.component';

@Component({
  selector: 'app-platform-dashboard-invitations',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    DashboardCardComponent,
    DashboardCardFooterDirective,
    DashboardCardHeaderActionsDirective,
    FontAwesomeModule,
    TranslocoPipe,
    PlatformDashboardInvitationItemComponent,
  ],
  templateUrl: './platform-dashboard-invitations.component.html',
  styleUrl: './platform-dashboard-invitations.component.scss',
})
export class PlatformDashboardInvitationsComponent {
  readonly dashboard = inject(PlatformDashboardService);
  readonly icons = {
    envelope: faEnvelope,
    chevronRight: faChevronRight,
  };
}
